import { createSlice } from "@reduxjs/toolkit";
const today = new Date();

const firstDay = new Date(today.getFullYear(), 0, 2);
const lastDay = new Date(today.getFullYear() + 1, 0, 1);

const initialState = {
  startDate: firstDay.toISOString().split("T")[0],
  endDate: lastDay.toISOString().split("T")[0],
  filters: true,
  reports: [],
};

const periodReports = createSlice({
  name: "periodReports",
  initialState,
  reducers: {
    setReports(state, action) {
      state.reports = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
  },
});

export const { setReports, setStartDate, setEndDate, setFilters } = periodReports.actions;
export default periodReports.reducer;
